import { useMutation as l } from "@apollo/client";
import { believeInviterSchema as u } from "../../deserialize/yup/adeptusCampaign.js";
import { deserializeData as d } from "../../graphql/deserialize/index.js";
import f from "../../graphql/mutation/sendBelieveInviter.js";
import { useState as p, useCallback as v } from "react";
const k = () => {
  const [e, { loading: a }] = l(f), [s, r] = p(!1);
  return {
    mutate: v(
      async (o) => {
        const { id: i, code: n, address: c } = o, m = await e({
          variables: { id: i, code: n, address: c }
        }), t = d(m, u) || !1;
        return r(t), t;
      },
      [e]
    ),
    data: s,
    loading: a
  };
};
export {
  k as default
};
//# sourceMappingURL=useSendBelieveInviter.js.map
